<template>
  <div
    class="sd-notif fade show"
    :class="notification.type"
    v-if="notification.message"
  >
    <svg-icon v-if="notification.type === 'success'" icon="checkmark_circle" class="success-icon" />
    <svg-icon v-if="notification.type === 'warning'" icon="information" class="warning-icon" />
    <svg-icon v-if="notification.type === 'danger'" icon="warning" class="danger-icon" />
      <div class="sd-notif-content">
        <strong>
          {{ notification.message.charAt(0).toUpperCase() + notification.message.slice(1) }}
          <span v-if="notification.redirect_url">
            <router-link
              :to="{ name: notification.redirect_url }"
              class="text-danger"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >
              {{ notification.redirect_msg }}
            </router-link>
          </span>
        </strong>
        <span v-if="notification.error && !notification.show_intake_message && !notification.vog_error">
          <span>&nbsp;</span>
          <router-link
            :to="{ name: 'contact' }"
            class="text-danger"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Laat ons weten wat er fout gaat</router-link
          >
          <span>&nbsp;</span>of probeer het later nog eens.
        </span>
        <span v-if="notification.show_intake_message">
          <br>
          <b>Plan eerst je intake. <a href="tel:0850481976">085 048 1976</a></b>
          <a v-if="isMobile()" href="https://wa.me/31850481976?text=Ik%20wil%20graag%20een%20intake%20gesprek%20inplannen"><img class="whatsapp-image" src="@/assets/whatsapp-square-brands.png" /></a>
          <a v-if="!isMobile()" href="https://web.whatsapp.com/send?phone=31850481976&text=Ik%20wil%20graag%20een%20intake%20gesprek%20inplannen"><img class="whatsapp-image" src="@/assets/whatsapp-square-brands.png" /></a>
        </span>
        <span v-if="notification.vog_error">
          <br>
          <router-link
            :to="{ name: 'applicant-step_1', params: { action: 'save' } }"
            class="text-danger"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            Heb je deze nog niet?
          </router-link>
        </span>
      </div>
<!--    <ul class="small pl-3 mb-0" v-if="notification.errors">-->
<!--      <li v-for="(value, key) in notification.errors" v-bind:key="key">-->
<!--        <strong>{{ value[0] }}</strong>-->
<!--      </li>-->
<!--    </ul>-->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      timeout: null
    };
  },
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  mounted() {
    // this.timeout = setTimeout(() => this.remove(this.notification), 5000);
  },
  watch: {
    notification: {
      immediate: true,
      handler() {
        let isObject = typeof this.notification.message;
        if (isObject == "object") {
          this.notification.errors = this.notification.message.errors;
          this.notification.message = this.notification.message.message;
          this.notification.noTryAgain = this.notification.message.noTryAgain;
        }
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  computed: {
    notificationTypeClass() {
      return `icon-${this.notification.type}`;
    }
  },
  methods: {
    ...mapActions("notification", ["remove"]),
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
  }
};
</script>

<style scoped>
.sd-notif-content {
    display: flex;
    flex-direction: column;
}

.whatsapp-image {
    width: 20px;
    height: 20px;
    margin-left: 5px;
}
</style>
